import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as S from "./styles";

import { Header } from '../../Components/Layout/header';
import { Footer } from '../../Components/Layout/footer';

import campoPremios from '../../assets/img/campoPremios.png';
import promoLogo from '../../assets/img/promoLogo.png';
import model from '../../assets/img/modelo.png';

function Home() {
    const navigate = useNavigate();

    useEffect(() => {
        const accessToken = localStorage.getItem('access_token');
        const typeUser = localStorage.getItem('user_type');
        if (accessToken && (typeUser == 'participante' || typeUser == 'supervisor')) {
            navigate('/premios/meus');
        }
    }, [navigate]);

    return (
        <S.Container>
            <Header isLogged={false} />

            <section className="relative overflow-hidden">
                <div className="container max-w-large">
                    <div className="relative md:w-1/2 min-h-[calc(100vh_-_100px)] max-md:pb-16 py-20 flex flex-col items-start justify-center">
                        <img src={promoLogo} alt="Logo da promoção" className="max-w-[40vw] max-h-[55vh] pointer-events-none" />

                        <img src={model} alt="Modelo da promoção" className="md:hidden absolute -right-1/2 bottom-0 max-w-[140%] opacity-50 pointer-events-none" />

                        <div className="relative mt-16 max-w-[400px]">
                            <h1 className="text-5xl 2xl:text-[49px] font-secondary text-primary text-balance">Vista a camisa, entre em campo</h1>
                            <h1 className="text-5xl 2xl:text-[52px] font-secondary text-primary italic font-bold text-balance">e conquiste seus prêmios.</h1>
                        </div>
                    </div>
                </div>

                <div className="md:absolute top-0 right-0 bottom-0 left-1/2 bg-tertiary flex flex-col items-center justify-center max-md:pb-10 p-4">
                    <img src={campoPremios} alt="Ilustração do campo de prêmios" className="max-w-[90%] pointer-events-none" />

                    <Link to="/tutorial" aria-label="Conheça o programa de prêmios" className="flex items-center gap-4 bg-primary text-white py-3 px-10 rounded-full text-xl font-semibold mt-6 transition-all hover:scale-105">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="33" viewBox="0 0 28 33" className="fill-white">
                            <path d="M14.777,2.924a2,2,0,0,1,3.446,0l13,22.061A2,2,0,0,1,29.5,28H3.5a2,2,0,0,1-1.723-3.015Z" transform="translate(28) rotate(90)"/>
                        </svg>

                        Conheça o programa
                    </Link>

                </div>

                <img src={model} alt="Modelo da promoção" className="hidden md:block absolute -right-1/3 bottom-0 left-1/2 -translate-x-1/2 -ml-10 max-h-[75%] 2xl:max-h-[85%] pointer-events-none" />
            </section>

            <Footer />
        </S.Container>
    );
}

export default Home;